import styled from 'styled-components'
import { Link } from 'react-router-dom'

const itemBase = `
  display: block;
  padding: 12px 20px;
  color: #fff;
  text-decoration: none;
  font-size: 15px;
  transition: background-color 0.2s, border-color 0.2s;
  border-left: 3px solid transparent;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
  }
`

export const Overlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  transition:
    opacity 0.25s ease,
    visibility 0.25s ease;
  z-index: 200;
`

export const Drawer = styled.aside<{ isOpen: boolean }>`
  width: 280px;
  max-width: 85vw;
  background-color: #000;
  color: #fff;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: auto;
  transform: translateX(${(props) => (props.isOpen ? '0' : '-100%')});
  transition: transform 0.25s ease;
  z-index: 201;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.3);
`

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  background-color: #c4bfa8;
  color: #000;
  font-weight: 600;
  font-size: 16px;
`

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #000;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px;
`

export const SideNavSection = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

export const SideNavTitle = styled.div`
  padding: 10px 20px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const SideNavItem = styled(Link)<{ isActive?: boolean }>`
  ${itemBase}
  background-color: ${(props) =>
    props.isActive ? 'rgba(255, 255, 255, 0.12)' : 'transparent'};
  border-left-color: ${(props) => (props.isActive ? '#fff' : 'transparent')};
`

// Reports nav item - always active, no dynamic prop needed
export const SideNavActiveItem = styled(Link)`
  ${itemBase}
  background-color: rgba(255, 255, 255, 0.12);
  border-left-color: #fff;
`

export const SideNavExternalLink = styled.a`
  ${itemBase}
`

// Account dropdown styles for SideNav
export const SideNavAccountButton = styled.button<{ $isOpen?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 40px);
  margin: 0 20px;
  padding: 12px 16px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
  transition:
    background-color 0.2s,
    border-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
  }

  svg {
    transition: transform 0.2s;
    transform: rotate(${(props) => (props.$isOpen ? '180deg' : '0deg')});
  }
`

export const SideNavAccountDropdown = styled.div<{ $isOpen: boolean }>`
  display: ${(props) => (props.$isOpen ? 'block' : 'none')};
  margin: 8px 20px 0;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  overflow: hidden;
  max-height: 250px;
  overflow-y: auto;
`

export const SideNavSearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.6);
`

export const SideNavSearchInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`

export const SideNavAccountItem = styled.button<{ $isSelected?: boolean }>`
  display: block;
  width: 100%;
  padding: 12px 16px;
  background-color: ${(props) =>
    props.$isSelected ? 'rgba(255, 255, 255, 0.15)' : 'transparent'};
  border: none;
  color: #fff;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`

export const SideNavNoResults = styled.div`
  padding: 12px 16px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  text-align: center;
`
